export * from './status-detalhe-conferencia-de-fatura.pipe';
